export const BUNDLES_HEAD_TITLE = 'Critical Thinking Bundles';
export const BUNDLES_PAGE_TITLE = 'Critical Thinking Bundles';

const BUNDLES_HEAD_DESCRIPTION_TEMPLATE =
    'Bundles of critical thinking courses, worksheets, and lesson plans for {audience} covering logical fallacies, data analysis, symbolic logic, and more.';

const has_selection = (selected) => selected && selected.path !== '';
const get_audience_label = (selected) =>
    has_selection(selected)
        ? selected.title.toLowerCase().replace(/^for\s+/, '')
        : 'kids and teens';

export function get_bundles_head_title(selected) {
    return has_selection(selected)
        ? `${BUNDLES_HEAD_TITLE} ${selected.title.toLowerCase()}: Critikid`
        : `${BUNDLES_HEAD_TITLE} for Kids and Teens: Critikid`;
}

export function get_bundles_head_description(selected) {
    const audience = get_audience_label(selected);

    return BUNDLES_HEAD_DESCRIPTION_TEMPLATE.replace('{audience}', audience);
}

export const bundles_nav_items = [
    {
        path: '',
        title: 'For All Ages',
        min_age: null,
        max_age: null
    },
    {
        path: 'for-8-12-years-old',
        title: 'For ages 8–12',
        min_age: 8,
        max_age: 12
    },
    {
        path: 'for-13-and-up',
        title: 'For ages 13+',
        min_age: 13,
        max_age: 18
    }
];
